export function getSecurityName(
  shortName: string | null,
  longName: string | null,
  upperCaseTickerId: string,
  type: string | null = null
) {
  return type === "CUR" || upperCaseTickerId.split(":")[1] === "CUR"
    ? shortName || longName || upperCaseTickerId
    : longName || shortName || upperCaseTickerId;
}
